<script setup lang="ts">
import { toRefs } from 'vue';

import { GrammarSectionHeader } from '@nora-monorepo/grammar-ui';
import type { SymbolPackDTO } from '@nora-monorepo/nora-api-client';

import SymbolList from '#nora-ui/map/components/drawtools/symbol-tool/SymbolList.vue';
import type { SymbolTool } from '#nora-ui/map/drawtools/symbol-tool/symbol-tool';

interface Props {
  symbolPack: SymbolPackDTO;
  mapId: string;
  tool: SymbolTool;
}

const props = defineProps<Props>();
const { symbolPack } = toRefs(props);
</script>

<template>
  <section class="flex flex-col">
    <GrammarSectionHeader
      :label="symbolPack.name"
      header-type="form-header"
      class="pb-2 px-1"
    />
    <SymbolList
      :symbol-pack="symbolPack"
      :map-id="mapId"
      :tool="tool"
    />
  </section>
</template>
